import React from "react";
import { PageHeader } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import { MyBreadcrumb } from "utils";
import InvoiceForm from "./form";

export default function InvoiceCreate() {
  return (
    <div>
      <MyBreadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Billing", path: "" },
          { label: "Invoices", path: "/billing/invoices" },
          { label: "Create", path: "" },
        ]}
      />
      <PageHeader
        ghost={false}
        avatar={{ icon: <FileTextOutlined /> }}
        title="Create Invoice"
        style={{ marginBottom: 16 }}
      />
      <InvoiceForm />
    </div>
  );
}
